export const noticiasData = [
    {
        title: "Nueva pagina web 2026",
        date: "23/10/2026",
        content: "Inauguramos nuestra nueva página web 2026. Pronto estará la posibilidad de pagar la mensualidad de forma online.",        
    },
    {
        title: "Financiamiento Compartido Trienio 2026",
        date: "23/10/2026",
        content: "A continuación, link de descarga a documento con información sobre Financiamiento Compartido 2025-2026-2027 para padres y apoderados.",
        pdf: "/assets/pdfs/trienios/TRIENIO_ 2025-2027.pdf"
    },
    {
        title: "¡Nueva página web!",
        date: "23/10/2026",
        content: "Contamos con una nueva página web pensada en ser un lugar de fácil acceso para padres, apoderados y estudiantes. Aquí encontrarás información relevante y actualizada sobre nuestro colegio.",
    },
    {
        title: "Nueva sección Noticias",
        date: "01/10/2026",
        content: "Nuestra página web cuenta con una sección de noticias, donde podrás encontrar las últimas noticias de nuestro colegio.",
    }
    
];